module.exports = __webpack_public_path__ + "img/illustrazione.e4dfd6f9.png";